import React, { ReactNode, useEffect } from "react";
import { usePageHeaderContext } from "./PageHeaderContext";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export default function PageHeader({
  title,
  subtitle,
  actions,
}: PageHeaderProps) {
  const headerContext = usePageHeaderContext();
  const setPageHeader = headerContext?.setPageHeader;

  useEffect(() => {
    if (!setPageHeader) return;

    setPageHeader({ title, subtitle, actions });

    return () => {
      setPageHeader(null);
    };
  }, [actions, setPageHeader, subtitle, title]);

  if (headerContext) {
    return null;
  }

  return (
    <div className="page-header-shell">
      <div>
        <h1 className="page-header-title">{title}</h1>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
